import detailStyles from '../ChallengeDetail.module.scss';

export const AutomaticDrawPrizesLevelDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Чем больше игроков участвует в розыгрыше за серые билеты — тем больше сертификатов разыгрывается в редких, эпических и легендарных розыгрышах.
                </div>
            </p>
        </div>
    );
}